import parser from "venuescanner-js/utils/typeParser";
const cleanObject = (schema = {}, props) => {
  if (props === null || typeof props === "undefined") return null;
  const type = typeof schema === "string" ? schema : schema.type;
  if (schema.ref) {
    return props;
  } else if (type === "any" || type === "object") {
    return props;
  } else if (parser[type]) {
    return parser[type](props);
  } else if (type === "array") {
    return props instanceof Array
      ? schema.schema
        ? props.map((prop) => cleanObject(props.schema, prop))
        : props
      : [];
  } else if (schema instanceof Array) {
    return props instanceof Array
      ? props.map((prop) => cleanObject(schema[0], prop))
      : [];
  } else if (typeof schema === "object") {
    return cleaner(schema, props);
  }
};
const cleaner = (schema = {}, props = {}) => {
  const clean = {};
  Object.keys(schema).forEach((key) => {
    clean[key] = cleanObject(schema[key], props[key]);
    // if (typeof props[key] === 'undefined') console.log(schema[key], props[key], clean[key])
  });
  return clean;
};

export default cleaner;
